import { FC } from 'react';
import { ModelTypeEnum, useLayerStore } from './layerStore';
import { CanvasControlButtonGroup } from '../CanvasControls/CanvasControlButtonGroup';

export const ModelTypeControls: FC = () => {
  const { modelType: type, setModelType: setType } = useLayerStore();

  return (
    <CanvasControlButtonGroup
      title='Model Type'
      value={type}
      onChange={(value) => setType(value as ModelTypeEnum)}
      options={[
        { value: ModelTypeEnum.Standing, label: 'Standing' },
        { value: ModelTypeEnum.Bent, label: 'Bent' },
      ]}
    />
  );
};
